const RevenueSpendByAccountPageLangKey = [
	'btn_show_empty_spend_agency_columns',
	'btn_hide_empty_spend_agency_columns'
] as const

type IRevenueSpendByAccountPageLangKey = typeof RevenueSpendByAccountPageLangKey[number]

export type IRevenueSpendByAccountPageLang = {
	revenue_spend_by_account_page: Record<IRevenueSpendByAccountPageLangKey, string>
}

const langEntries = RevenueSpendByAccountPageLangKey.map(
	(key: IRevenueSpendByAccountPageLangKey) => [key, `revenue_spend_by_account_page.${key}`]
)

const langObj: Record<IRevenueSpendByAccountPageLangKey, string> = Object.fromEntries(langEntries)

export const REVENUE_SPEND_BY_ACCOUNT_PAGE_LANG_KEY: IRevenueSpendByAccountPageLang = {
	revenue_spend_by_account_page: langObj
}
